// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602271642/js/" + chunkId + "." + {"44":"79c5141b","225":"a30f441b","481":"bd595aa2","486":"e8ba83bb","770":"662b09f3"}[chunkId] + ".0.21495930717764433.chunk.js";
};